// import { createSlice } from "@reduxjs/toolkit";
// import {getEmployees} from '../reduxApi/employeeReduxApi'

// const employeeSlice = createSlice({
//     name: 'employee',
//     initialState: {
//         status: 'idel',
//         isFiltered: false,
//         employee: [],
//     },
//     reducers: {
//          setFilteredStatus: (state, action) => {
//             state.isFiltered = action.payload;
//         },
//         deleteEmployeeAction: (state, action) => {
//             action.payload.forEach((id) => {
//                 const index = state.employee.findIndex((item) => item.employees.ROWID === id);
//                 if (index !== -1) {
//                     state.employee.splice(index, 1);
//                 }
//             });
//         },
//         updateEmployeeAction: (state, action) => {
//             console.log("action", action.payload)
//             const index = state.employee.findIndex((item) => item.employees.ROWID === action.payload.ROWID)
//             if (index != -1) {
//                 state.employee.splice(index, 1, { employees: action.payload })
//             }
//         },
//         addEmployeeAction: (state, action) => {
//             console.log("Adding employee:", action.payload);
//             const temp = action.payload.formData;
//             console.log("temp",temp)
//             temp.ROWID = action.payload.ROWID
//             state.employee.unshift({employees:temp});
//         }
//     },
//     extraReducers: (builder) => {
//         builder.addCase(getEmployees.pending, (state, action) => {
//             state.status = 'pending'
//         })
//             .addCase(getEmployees.fulfilled, (state, action) => {
//                 state.status = 'fulfilled'
//                 console.log("testing employee Data", action.payload)
//                 state.employee = action.payload.data.data
// ;
//             })
//     }
// })
// export const { deleteEmployeeAction, updateEmployeeAction, addEmployeeAction,setFilteredStatus } = employeeSlice.actions
// export default employeeSlice.reducer

import { createSlice } from "@reduxjs/toolkit";
import { getEmployees } from '../reduxApi/employeeReduxApi'

const employeeSlice = createSlice({
    name: 'employee',
    initialState: {
        status: 'idel',
        isFiltered: false,
        employee: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteEmployeeAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.employee.findIndex((item) => item.employees.ROWID === id);
                if (index !== -1) {
                    state.employee.splice(index, 1);
                }
            });
        },
        updateEmployeeAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.employee.findIndex((item) => item.employees.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.employee.splice(index, 1, { employees: action.payload })
            }
        },
        addEmployeeAction: (state, action) => {
            console.log("Adding employee:", action.payload);
            const temp = action.payload.formData;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID
            state.employee.unshift({employees:temp});
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmployees.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(getEmployees.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing employee Data", action.payload)
                // Now action.payload is the response.data directly
                state.employee = action.payload.data;
            })
            .addCase(getEmployees.rejected, (state, action) => {
                state.status = 'rejected'
            })
    }
})

export const { deleteEmployeeAction, updateEmployeeAction, addEmployeeAction, setFilteredStatus } = employeeSlice.actions
export default employeeSlice.reducer